import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
    state: () => ({ 
        shadowTeamClubPlayers: [], 
        shadowTeamAlienPlayers: [],

        shortListClubPlayers: [], 
        shortListAlienPlayers: [],

        firstPlayerForComparison: null,
        secondPlayerForComparison: null,

        scoringRadarChartSettings: {}
    }),
})